import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { checkPhoneVerificationPublic } from "./PhoneVerificationSignupAPI"

const initialState = {
    loading: false,
    otpSent: false,
    success: false,
    error: null,
}

// Thunk to check phone verification code
export const checkPhoneVerificationPublicAsync = createAsyncThunk(
    "checkPhoneVerificationPublic",
    async ({ mobile, code }, { rejectWithValue }) => {
        try {
            // Pass as object with mobile and code properties
            const data = await checkPhoneVerificationPublic({ mobile, code })
            return data
        } catch (error) {
            return rejectWithValue(error.message || "Verification failed.")
        }
    },
)

const checkPhoneVerificationPublicSlice = createSlice({
    name: "CheckPhoneVerification",
    initialState,
    reducers: {
        resetPhoneVerificationState: (state) => {
            state.loading = false
            state.otpSent = false
            state.success = false
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkPhoneVerificationPublicAsync.pending, (state) => {
                state.loading = true
                state.success = false
                state.error = null
            })
            .addCase(checkPhoneVerificationPublicAsync.fulfilled, (state) => {
                state.loading = false
                state.otpSent = false
                state.success = true
                state.error = null
            })
            .addCase(checkPhoneVerificationPublicAsync.rejected, (state, action) => {
                state.loading = false
                state.success = false
                state.error = action.payload || "Verification failed."
            })
    },
})

export const { resetPhoneVerificationState } = checkPhoneVerificationPublicSlice.actions
export default checkPhoneVerificationPublicSlice.reducer